import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledCaption,
  StyledItem,
  StyledItems,
  StyledSection,
  StyledValue
} from './LocationPreference.styled';
import MethodologyAnchor from './MethodologyAnchor';

const LocationPreference: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const items = [
    {
      type: 'big',
      value: 61.41035401598782,
      label: t('developers.location.remote')
    },
    {
      type: 'medium',
      value: 31.747240197944425,
      label: t('developers.location.hybrid')
    },
    {
      type: 'small',
      value: 11.36277122192615,
      label: t('developers.location.onsite')
    }
  ];

  return (
    <StyledSection>
      <Heading3>{t('developers.location.title')}</Heading3>
      <div
        dangerouslySetInnerHTML={{
          __html: t('developers.location.desc')
        }}
      ></div>
      <StyledItems>
        {items.map((item) => (
          <StyledItem key={item.type}>
            <StyledValue className={item.type}>
              {item.value.toFixed(1)}%
            </StyledValue>
            <StyledCaption>{item.label}</StyledCaption>
          </StyledItem>
        ))}
      </StyledItems>
      <MethodologyAnchor />
    </StyledSection>
  );
};

export default LocationPreference;
